import confetti from "canvas-confetti";

let voteConfetti = null;

export function playVoteConfettiAtPointer(pointerLike) {
  if (prefersReducedMotion()) return;
  const origin = toConfettiOrigin(pointerLike);
  if (!origin) return;

  try {
    getVoteConfetti()({
      particleCount: 56,
      spread: 62,
      startVelocity: 36,
      gravity: 1.08,
      scalar: 0.92,
      ticks: 150,
      zIndex: 1200,
      origin,
      colors: ["#2563eb", "#1d4ed8", "#f59e0b", "#d97706", "#b45309"]
    });
  } catch {
    // Ignore confetti rendering failures.
  }
}

function getVoteConfetti() {
  if (voteConfetti) return voteConfetti;
  voteConfetti = typeof confetti.create === "function"
    ? confetti.create(null, { resize: true, useWorker: false })
    : confetti;
  return voteConfetti;
}

export function toConfettiOrigin(pointerLike) {
  const viewportWidth = getViewportWidth();
  const viewportHeight = getViewportHeight();
  if (viewportWidth <= 0 || viewportHeight <= 0) {
    return null;
  }

  const point = getPointerPoint(pointerLike);
  if (!point) return null;

  return {
    x: clamp(point.clientX / viewportWidth, 0, 1),
    y: clamp(point.clientY / viewportHeight, 0, 1)
  };
}

function getPointerPoint(pointerLike) {
  if (!pointerLike || typeof pointerLike !== "object") {
    return null;
  }

  const source = pointerLike.nativeEvent && typeof pointerLike.nativeEvent === "object"
    ? pointerLike.nativeEvent
    : pointerLike;

  if (typeof source.clientX === "number" && typeof source.clientY === "number") {
    return { clientX: source.clientX, clientY: source.clientY };
  }

  const touch = source.changedTouches?.[0] || source.touches?.[0];
  if (touch && typeof touch.clientX === "number" && typeof touch.clientY === "number") {
    return { clientX: touch.clientX, clientY: touch.clientY };
  }

  return null;
}

function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  if (typeof window.matchMedia !== "function") return false;

  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}

function getViewportWidth() {
  if (typeof window === "undefined") return 0;
  return Number(window.innerWidth || 0);
}

function getViewportHeight() {
  if (typeof window === "undefined") return 0;
  return Number(window.innerHeight || 0);
}

function clamp(value, min, max) {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}
